import { Box, Button, Grid, Typography, styled } from "@mui/material";
import { getIncomeTaxProfile, createRequest } from "api/services/automation/income-tax-tan";
import { useMutation, useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { ResType } from "types";
import CachedIcon from "@mui/icons-material/Cached";
import { useState } from "react";
import { snack } from "components/toast";
import Loader from "components/Loader";
import moment from "moment";
import { toast } from "react-toastify";
import { Permissions } from "data/permissons";
import ValidateAccess from "components/ValidateAccess";
import AccessDenied from "views/atom-pro/Access/accessDenide";
import SelectModulePopUp from "./selectModulePopUp";
import Table from "components/Table";

interface StyledSpanProps {
  bgColor?: string; // Define bgColor prop here
}

const StyledSpan = styled("span")<StyledSpanProps>(({ theme, bgColor }) => ({
  backgroundColor: bgColor || "#ffffff",
  padding: "5px",
  fontSize: "14px",
  fontWeight: "500",
  borderRadius: "3px",
}));

const TanClientFullView = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState<any>("");
  const [keyPersonDetails, setKeyPersonDetails] = useState<any>("");
  const [issueOrReceiveOpen, setIssueOrReceiveOpen] = useState(false);
  const [selectedModules, setSelectedModules] = useState<string[]>([]);
  const [password, setPassword] = useState("YourSecretPassword123!");
  const [tranceSelectedModules, setTranceSelectedModules] = useState<string[]>([]);
  const [tanCredentilas, setTanCredentilas] = useState<any>("");

  const getItem = localStorage.getItem("automationSyncStatus");
  const [checkAccess, setCheckAccess] = useState(true);
  const [lastSync, setLastSync] = useState("");
  const [lastTracesSync, setLastTraceSync] = useState("");
  const { data, isLoading }: ResType = useQuery(
    ["get-income-tax-tan-profile", params.incometaxid],
    getIncomeTaxProfile,
    {
      onSuccess: (res: any) => {
        setCheckAccess(res?.data?.checkClientCredentials);
        setProfileData(res?.data?.profileDetails);
        setKeyPersonDetails(res?.data?.keyPersonDetails);
        setLastSync(res?.data?.lastCompletedMachine);
        setTanCredentilas(res?.data?.clientCredential);
        setLastTraceSync(res?.data?.lastCompletedTracesMachine);

        if (res?.data?.profileDetails) {
          setPassword(
            `${res?.data?.profileDetails?.pan?.toLowerCase()}${moment(
              res?.data?.profileDetails?.dob
            ).format("DDMMYYYY")}`
          );
        }

        // if (res?.data?.lastCompletedMachine) {
        //   if (res?.data?.lastCompletedMachine?.remarks !== "Success") {
        //     snack.error(res?.data?.lastCompletedMachine?.remarks);
        //   }
        // }
      },
      cacheTime: 0,
    }
  );

  const { mutate: sendRequest, isLoading: LLLLLL } = useMutation(createRequest, {
    onSuccess: (res) => {
      if (res?.data) {
        if (res?.data?.startsWith("Successfully")) {
          snack.success(res?.data);
        } else {
          snack.error(res?.data);
        }
        setTimeout(() => {
          navigate(`/atom-pro/income-tax-tan/incometax/${params.incometaxid}/client-status`);
        }, 1000);
      } else {
        snack.error(res?.data);
      }
    },
  });

  const handleSyncc = () => {
    setIssueOrReceiveOpen(true);
  };

  const handleIncomeTaxSync = () => {
    sendRequest({
      id: params.incometaxid,
      data: {
        tanData: {
          requests: selectedModules,
        },
        tracesData: {
          requests: tranceSelectedModules,
        },
      },
    });
    setIssueOrReceiveOpen(false);
  };

  const handleSelectionChange = (selectedValues: string[]) => {
    setSelectedModules(selectedValues);
  };

  const handleTraceSelectionChange = (selectedValues: string[]) => {
    setTranceSelectedModules(selectedValues);
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(password);
      toast.success("Password copied");
    } catch (err) {
      console.error("Failed to copy: ", err);
      toast.error("Failed to copy password.");
    }
  };

  let columns: any = [
    {
      key: "name",
      title: "Name",
    },
    {
      key: "pan",
      title: "PAN",
    },
    {
      key: "dob",
      title: "DOB",
      render: (row: any) => {
        return (
          <Typography>{row?.dob ? moment(row?.dob).format("DD MMM YYYY") || "-" : "NA"}</Typography>
        );
      },
    },
    {
      key: "gender",
      title: "Gender",
      render: (row: any) => {
        return <Typography>{row?.gender ? row?.gender : "-"}</Typography>;
      },
    },
    {
      key: "residentialStatus",
      title: "Residential Status",
      render: (row: any) => {
        return <Typography>{row?.residentialStatus ? row?.residentialStatus : "-"}</Typography>;
      },
    },
    {
      key: "dscExpDate",
      title: "DSC Expiry Date",
      render: (row: any) => {
        return (
          <Typography>
            {row?.dscExpDate ? moment(row?.dscExpDate).format("DD MMM YYYY") || "-" : "NA"}
          </Typography>
        );
      },
    },

    {
      key: "mobNo",
      title: "Mobile #",
    },
    {
      key: "eMail",
      title: "E Mail",
    },
  ];
  if (isLoading) return <Loader />;
  return (
    <>
      {!checkAccess && <AccessDenied />}
      {checkAccess && (
        <Box>
          <Box height="70vh" overflow="auto">
            <Box>
              <Grid container>
                <Grid item xs={6}></Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    Last Synced At (TAN):{" "}
                    {lastSync?.["updatedAt"]
                      ? moment(lastSync["updatedAt"]).format("DD MMM YYYY,HH:mm A")
                      : "--"}
                  </Typography>
                  <Typography variant="body2">
                    Last Synced At (Traces):{" "}
                    {lastTracesSync?.["updatedAt"]
                      ? moment(lastTracesSync["updatedAt"]).format("DD MMM YYYY,HH:mm A")
                      : "--"}
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  {/* <ValidateAccess name={Permissions.SYNC_ACCESS_TAN}> */}
                    {/* <Button onClick={handleSyncc} variant="contained" startIcon={<CachedIcon />}>
                      SYNC Data
                    </Button> */}
                  {/* </ValidateAccess> */}
                </Grid>
              </Grid>
              <SelectModulePopUp
                open={issueOrReceiveOpen}
                setOpen={setIssueOrReceiveOpen}
                onSelectionChange={handleSelectionChange}
                onSync={handleIncomeTaxSync}
                onTraceSelectionChange={handleTraceSelectionChange}
                tanClientCredentials={tanCredentilas}
              />
              {profileData === "" || profileData === undefined ? (
                <Box textAlign="center" mt={20}>
                  <Typography variant="subtitle1" color="rgba(0,0,0,0.5)">
                    No Data present
                  </Typography>
                </Box>
              ) : (
                <>
                  <Box height="70vh" overflow="auto">
                    <Typography variant="h6" color={"primary"} mb={1} ml={1}>
                      Profile Info
                    </Typography>
                    <Box
                      style={{ border: "1px solid #d1d1e0", borderRadius: "5px" }}
                      p={1}
                      mb={2}
                      ml={1}
                      mr={1}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={4}>
                          <Box
                            style={{
                              // border: "1.5px solid #d1d1e0",
                              // padding: "3px",
                              marginBottom: "3px",
                              borderRadius: "7px",
                            }}
                          >
                            <StyledSpan
                            // bgColor="#ffffcc"
                            >
                              TAN
                            </StyledSpan>
                            <Typography variant="h6" color="primary" mb={1}>
                              {profileData?.tanNumber ? profileData?.tanNumber : "-"}
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={4}>
                          <Box
                            style={{
                              // border: "1.5px solid #d1d1e0",
                              // padding: "3px",
                              marginBottom: "3px",
                              borderRadius: "7px",
                            }}
                          >
                            <StyledSpan
                            // bgColor="#ffe6e6"
                            >
                              Name (As per TAN)
                            </StyledSpan>
                            <Typography variant="h6" color="primary" mb={1}>
                              {profileData?.name ? profileData?.name : "-"}
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={4}>
                          <Box
                            style={{
                              // border: "1.5px solid #d1d1e0",
                              // padding: "3px",
                              marginBottom: "3px",
                              borderRadius: "7px",
                            }}
                          >
                            <StyledSpan
                            // bgColor="#e6ffff"
                            >
                              Date of TAN Allotment
                            </StyledSpan>
                            <Typography variant="h6" color="primary" mb={1}>
                              {profileData?.dateOfAllotment
                                ? moment(profileData?.dateOfAllotment).format("DD MMM YYYY")
                                : "--"}
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={4}>
                          <Box
                            style={{
                              // border: "1.5px solid #d1d1e0",
                              // padding: "3px",
                              marginBottom: "3px",
                              borderRadius: "7px",
                            }}
                          >
                            <StyledSpan
                            // bgColor="#ccfff5"
                            >
                              PAN
                            </StyledSpan>
                            <Typography variant="h6" color="primary" mb={1}>
                              {profileData?.orgPan ? profileData?.orgPan : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={4}>
                          <Box
                            style={{
                              // border: "1.5px solid #d1d1e0",
                              // padding: "3px",
                              marginBottom: "3px",
                              borderRadius: "7px",
                            }}
                          >
                            <StyledSpan
                            // bgColor="#ffe6e6"
                            >
                              Name (As Per PAN)
                            </StyledSpan>
                            <Typography variant="h6" color="primary" mb={1}>
                              {profileData?.nameAsPerPan ? profileData?.nameAsPerPan : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={4}>
                          <Box
                            style={{
                              // border: "1.5px solid #d1d1e0",
                              // padding: "3px",
                              marginBottom: "3px",
                              borderRadius: "7px",
                            }}
                          >
                            <StyledSpan
                            // bgColor="#ffe6e6"
                            >
                              PAN Status
                            </StyledSpan>
                            <Typography variant="h6" color="primary" mb={1}>
                              {profileData?.panStatus ? profileData?.panStatus : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>

                    <Typography variant="h6" color={"primary"} mb={1} ml={1}>
                      Contact Info
                    </Typography>
                    <Box
                      style={{ border: "1px solid #d1d1e0", borderRadius: "5px" }}
                      p={1}
                      mb={2}
                      ml={1}
                      mr={1}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={3}>
                          <Box
                            style={{
                              // border: "1.5px solid #d1d1e0",
                              // padding: "3px",
                              marginBottom: "3px",
                              borderRadius: "7px",
                            }}
                          >
                            <StyledSpan
                            // bgColor="#ffe6e6"
                            >
                              Primary Number
                            </StyledSpan>
                            <Typography variant="h6" color="primary" mb={1}>
                              {profileData?.primaryNumber ? profileData?.primaryNumber : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={3}>
                          <Box
                            style={{
                              // border: "1.5px solid #d1d1e0",
                              // padding: "3px",
                              marginBottom: "3px",
                              borderRadius: "7px",
                            }}
                          >
                            <StyledSpan
                            // bgColor="#ffffcc"
                            >
                              Primary Email
                            </StyledSpan>
                            <Typography variant="h6" color="primary" mb={1}>
                              {profileData?.primaryEmail ? profileData?.primaryEmail : "-"}
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={3}>
                          <Box
                            style={{
                              // border: "1.5px solid #d1d1e0",
                              // padding: "3px",
                              marginBottom: "3px",
                              borderRadius: "7px",
                            }}
                          >
                            <StyledSpan
                            // bgColor="#ffe6e6"
                            >
                              Secondary Number
                            </StyledSpan>
                            <Typography variant="h6" color="primary" mb={1}>
                              {profileData?.secondaryNumber ? profileData?.secondaryNumber : "-"}
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={3}>
                          <Box
                            style={{
                              // border: "1.5px solid #d1d1e0",
                              // padding: "3px",
                              marginBottom: "3px",
                              borderRadius: "7px",
                            }}
                          >
                            <StyledSpan
                            // bgColor="#e6ffff"
                            >
                              Secondary Email
                            </StyledSpan>
                            <Typography variant="h6" color="primary" mb={1}>
                              {profileData?.secondaryEmail ? profileData?.secondaryEmail : "-"}
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={3}>
                          <Box
                            style={{
                              // border: "1.5px solid #d1d1e0",
                              // padding: "3px",
                              marginBottom: "3px",
                              borderRadius: "7px",
                            }}
                          >
                            <StyledSpan
                            // bgColor="#ccfff5"
                            >
                              Communication Address
                            </StyledSpan>
                            <Typography variant="h6" color="primary" mb={1}>
                              {profileData?.commincationAddressedTo
                                ? profileData?.commincationAddressedTo
                                : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={8}>
                          <Box
                            style={{
                              // border: "1.5px solid #d1d1e0",
                              // padding: "3px",
                              marginBottom: "3px",
                              borderRadius: "7px",
                            }}
                          >
                            <StyledSpan
                            // bgColor="#ffe6e6"
                            >
                              Address
                            </StyledSpan>
                            <Typography variant="h6" color="primary" mb={1}>
                              {profileData?.address ? profileData?.address : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                    <Typography variant="h6" color={"primary"} mb={1} ml={1}>
                      Key Person(s) Info
                    </Typography>

                    <Box>
                      <Table
                        sx={{ height: "250px" }}
                        data={keyPersonDetails || []}
                        columns={columns}
                        loading={isLoading}
                      />
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default TanClientFullView;
